// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__e1mdO","content":"GlobalSearch_content__1chjJ"};